import React, { useEffect } from 'react';
import { Form, Input, Button, InputNumber, Switch } from 'antd';
import { AppSelectorInput } from './AppSelector';

const suggestedTags = [
  { label: 'General', value: 'General' },
  { label: 'Page speed', value: 'Page speed' },
  { label: 'Instant page', value: 'Instant page' },
  { label: 'Image optimization', value: 'Image optimization' },
  { label: 'Core Web Vitals', value: 'Core Web Vitals' },
  { label: 'SEO Audit', value: 'SEO Audit' },
  { label: 'Structured data', value: 'Structured data' },
  { label: 'Meta data templates', value: 'Meta data templates' },
  { label: 'Image alt optimization', value: 'Image alt optimization' },
  { label: 'Broken links', value: 'Broken links' },
  { label: 'Keyword research', value: 'Keyword research' },
  { label: 'Google Search Console', value: 'Google Search Console' },
  { label: 'LLMs.txt', value: 'LLMs.txt' },
  { label: 'Preload assets', value: 'Preload assets' },
  { label: 'Image file name', value: 'Image file name' },
  { label: 'Manual/AI meta', value: 'Manual/AI meta' },
  { label: 'Noindex', value: 'Noindex' },
  { label: 'Backlink', value: 'Backlink' },
  { label: 'Content optimization', value: 'Content optimization' },
];

const FaqForm = ({ item, _onClose, onSubmit }) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (item) {
      // Convert tags array to comma-separated string if needed
      const formData = {
        ...item,
        tags: Array.isArray(item.tags) ? item.tags.join(',') : item.tags,
      };
      form.setFieldsValue(formData);
    } else {
      form.resetFields();
    }
  }, [item, form]);

  const handleFinish = (values) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      onValuesChange={(changed, allValues) => {
        console.log('onValuesChange:', allValues);
      }}
    >
      <AppSelectorInput name="category" label="Show on app" required={true} placeholder="Show on app" />
      <Form.Item name="hide_on_app" valuePropName="checked" label="Hide on app (just show on tapita website)">
        <Switch checkedChildren="Hidden" unCheckedChildren="Visible" />
      </Form.Item>
      <Form.Item name="tags" label="Tags (comma separated)">
        <Input style={{ width: '100%' }} placeholder="Enter tags separated by commas" />
      </Form.Item>
      <div style={{ marginBottom: 24 }}>
        Suggested tags:{' '}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
          }}
        >
          {suggestedTags.map((sgt) => {
            return (
              <div
                style={{
                  marginInlineEnd: 12,
                  marginBottom: 10,
                  fontSize: 11,
                  padding: 5,
                  borderRadius: 3,
                  cursor: 'pointer',
                  border: 'solid 1px #eaeaea',
                }}
                key={sgt.label}
                onClick={() => {
                  const currentTags = form.getFieldValue('tags') || '';
                  const tagsArray = currentTags
                    .split(',')
                    .map((t) => t.trim())
                    .filter((t) => t);
                  if (!tagsArray.includes(sgt.value)) {
                    const newTags = [...tagsArray, sgt.value].join(',');
                    form.setFieldsValue({
                      tags: newTags,
                    });
                  }
                }}
              >
                {sgt.label}
              </div>
            );
          })}
        </div>
      </div>
      <Form.Item name="priority" label="Priority - higher on top">
        <InputNumber min={0} max={9999} step={1} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="question" label="Question">
        <Input.TextArea rows={2} />
      </Form.Item>
      <Form.Item name="answer" label="Answer">
        <Input.TextArea rows={6} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default FaqForm;

